import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getAllByUser } from 'apis/organizations.api';

const useGetAllByUser = (t, conds) => {
  const { data: organizationsData, ...rest } = useQuery(
    ['projectProposalOrganizationsByUser'],
    getAllByUser,
    { ...conds }
  );

  const organizations = useMemo(
    () =>
      organizationsData?.data?.map((e) => ({
        id: e?.id,
        name: t('lang') === 'vi' ? e?.name : e?.englishName,
      })) ?? [],
    [organizationsData, t]
  );

  return {
    data: organizations,
    ...rest,
  };
};

export default useGetAllByUser;
